import React, { Component } from 'react';
import * as UiConsts from '../../../../config/UiConstants';
import {firebaseAuth, serverIp, toCurrency, logComponentLoad } from '../../../../config/constants.js'
import axios from 'axios'
import { Table, Header, Divider } from 'semantic-ui-react';
import SearchOrderNumInReceipts from '../Billing/SearchOrderNumInReceipts';
import { checkAdminEmail } from '../../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import { Link } from 'react-router-dom';

class ReceiptList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            receipts: [],
            algoliaUser:''
        }
    }

    componentDidMount() {
        console.log("ddx13 ++++++ componentDidMount ");
        this.setState({ loading: true });

        // this.loadReceipts();

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");


            if (user) {
                //console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        })
    }

    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "ReceiptList");

        if (returnObject.algoliaUser && returnObject.algoliaUser.isAdmin && returnObject.algoliaUser.receiptList) {
            console.log("lcdx13 returnObject.algoliaUser && returnObject.algoliaUser.isAdmin:");
        
            this.loadReceipts();

          }
        

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    loadReceipts = () => {
        axios.post(serverIp + 'billing/getReceiptList', {
            apiKey: "ad#4fsdUUddf",
        })
            .then((response) => {
                console.log(response.data);

                if (response.data.result) {

                    if (response.data.receiptOrderNumsList && response.data.receiptOrderNumsList.length > 0) {
                        console.log("entx22 result:" + JSON.stringify(response.data.receiptOrderNumsList[0], null, 3));
                        this.setState({ loading: false, receipts: response.data.receiptOrderNumsList });
                    } else {

                        this.setState({ loading: false });

                        alert("Receipt list is empty");
                    }


                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })
            });
    }

    render() {


        const stockOrderTable = this.state.receipts.map((receipt) =>

            <Table.Row>
                <Table.Cell>
                    <Header as='h2' textAlign='center'>
                        {receipt.orderNum}
                    </Header>
                </Table.Cell>
                <Table.Cell singleLine>{receipt.dateStamp}</Table.Cell>
                <Table.Cell><Link to={'/dashboard/viewReceipt/' + receipt.reciepts.recieptNum}>{receipt.reciepts.recieptNum}</Link></Table.Cell>
                <Table.Cell>{toCurrency(receipt.reciepts.amountRec)}</Table.Cell>
                <Table.Cell>{toCurrency(receipt.reciepts.amountDep)}</Table.Cell>
                <Table.Cell>{toCurrency(receipt.reciepts.amountDep + receipt.reciepts.amountDep)}</Table.Cell>
                <Table.Cell>{receipt.reciepts.adminEmail}</Table.Cell>
                <Table.Cell>{receipt.order1.orderStatusRel.statusName}</Table.Cell>
                <Table.Cell textAlign='center'> {receipt.reciepts.checkString}</Table.Cell>
            </Table.Row>

        )

        const wholeUi = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.receiptList
            ? <div>
                <SearchOrderNumInReceipts />
                <br />
                <Divider horizontal>{'RECEIPT LIST'}</Divider>
                <Table celled padded>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell singleLine>ORDER NUMBER</Table.HeaderCell>
                            <Table.HeaderCell>DATE ENTERED</Table.HeaderCell>
                            <Table.HeaderCell>RECEIPT NUMBER</Table.HeaderCell>
                            <Table.HeaderCell>AMOUNT REC </Table.HeaderCell>
                            <Table.HeaderCell>AMOUNT DEP </Table.HeaderCell>
                            <Table.HeaderCell>TOTAL </Table.HeaderCell>
                            <Table.HeaderCell>ENTERED BY</Table.HeaderCell>
                            <Table.HeaderCell>STATUS </Table.HeaderCell>
                            <Table.HeaderCell>CHECK STRING</Table.HeaderCell>


                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {stockOrderTable}
                    </Table.Body>
                </Table>
            </div>
            :''

        return (this.state.loading ? <UiConsts.LoadingComponent /> :
            <div>
                {wholeUi}
            </div>);
    }
}

export default ReceiptList;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Receipts/ReceiptList.js